module.exports = __webpack_public_path__ + "static/img/a-1.2195bf80.png";